import { Check } from "lucide-react";
import { DEFAULT_COLOR } from "../../lib/colors";

/** Row/grid of round swatches (event and calendar colors). `null` = "use the calendar's color". */
export function ColorPicker({
  colors,
  value,
  onChange,
  calendarColor
}: {
  colors: Array<{ name: string; hex: string }>;
  value: string | null;
  onChange: (hex: string | null) => void;
  calendarColor?: string;
}) {
  const swatch = (hex: string | null, name: string) => {
    const fill = hex ?? calendarColor ?? DEFAULT_COLOR;
    const selected = (value ?? null) === hex;
    return (
      <button
        key={name}
        type="button"
        title={name}
        aria-label={name}
        aria-pressed={selected}
        onClick={() => onChange(hex)}
        style={{ width: 24, height: 24, borderRadius: 6, background: fill, display: "inline-flex", alignItems: "center", justifyContent: "center", color: "#fff" }}
      >
        {selected && <Check size={14} strokeWidth={3} />}
      </button>
    );
  };
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 24px)", gap: 10, padding: 12 }}>
      {colors.map((c) => swatch(c.hex, c.name))}
      {calendarColor !== undefined && swatch(null, "Cor da agenda")}
    </div>
  );
}
